module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Book image":"Book image","Upload files here":"Upload files here","Upload file":"Upload file","max_size{size}":"Maximum Upload File Size: {size}MB"},"it":{"Book image":"Immagine del libro","Upload files here":"Carica i file qui","Upload file":"Carica il file","max_size{size}":"Dimensione massima di caricamento del file: {size}MB"}}')
  delete Component.options._Ctor
}
